import React, { Component } from "react";
import { Card } from "react-bootstrap";
import { RefreshCw, Database, Clock, UploadCloud, ExternalLink, Check } from "react-feather";
import { Link } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import { config } from "../../../constants";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Box,
  Checkbox,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { getDailyStatsService, getMetricsService, getRowJoltedDataService } from "../../../services/dashboard";
import { CircularProgress, Button } from "@mui/material"
import axios from "axios";
import DatajoltSpinner from "../../../components/global/DatajoltSpinner";
import Row from "../../../components/global/Layout/Row";
import Col from "../../../components/global/Layout/Col";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

export default class Statistics extends Component {
  constructor(props) {
    super(props);
    // Initialize the state with the last 7 days
    const today = new Date();
    const labels = [];
    for (let i = 6; i >= 0; i--) {
      const date = new Date(today);
      date.setDate(today.getDate() - i);
      labels.push(date.toISOString().split('T')[0]);
    }

    this.state = {
      metrics: false,
      isDWHCreatorShown: false,
      dailyStats: {
        labels: labels, // Last 7 days labels
        datasets: [
          {
            label: "DAG Success Runs",
            data: Array(7).fill(0), // 0s for success runs
            backgroundColor: "rgba(75, 192, 192, 0.6)",
          },
          {
            label: "DAG Failed Runs",
            data: Array(7).fill(0), // 0s for failed runs
            backgroundColor: "rgba(255, 99, 132, 0.6)",
          },
        ],
      },
      tasksData: {
        labels: labels,
        datasets: []
      },
      snowflakeCostsData: {
        labels: [],
        datasets: []
      },
      animatedDwh: 0,
      animatedTaps: 0,
      animatedDags: 0,
      animatedPushes: 0,
      isAnimating: false,
      snowflakeTimeRange: '7d',
      dagTimeRange: '7d',
      tasksTimeRange: '7d',
      rowsTimeRange: '7d',
      selectedTaskTypes: {
        tap: true,
        dbt: true,
        push: true
      },
      taskStatusFilter: 'all',
      snowflakeMtdCost: null,
      selectedSources: [],
      availableSources: [],
      rowsViewType: 'source', // 'source' or 'table'
      selectedTables: [],
      availableTables: [],
      rawRowsData: null, // Store the raw data from API
      emptyChartData: {
        labels: labels, // Last 7 days labels
        datasets: [
          {
            label: "Rows Replicated",
            data: Array(7).fill(0), // No data
            backgroundColor: "rgba(169, 169, 169, 0.6)", // Dark grey color
          },
        ],
      }
    };
  }
  
  componentDidMount() {
    this.setState({ progress: 70 });
    this.getMetrics();
    this.getDailyStats(7);
    this.getRowJoltedData(7);
    this.getSnowflakeCosts(7);
    this.getTaskRunsData(7);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.metrics && !prevState.metrics && !this.state.isAnimating) {
      this.setState({ isAnimating: true });
      
      const targetDwh = this.state.metrics.dwh || 0;
      const targetTaps = this.state.metrics.taps || 0;
      const targetDags = this.state.metrics.dags || 0;
      const targetPushes = this.state.metrics.pushes || 0;
      
      const duration = 1000;
      const steps = 20;
      const interval = duration / steps;
      
      const dwhIncrement = targetDwh / steps;
      const tapsIncrement = targetTaps / steps;
      const dagsIncrement = targetDags / steps;
      const pushesIncrement = targetPushes / steps;
      
      let currentStep = 0;
      
      const timer = setInterval(() => {
        currentStep++;
        
        if (currentStep >= steps) {
          this.setState({
            animatedDwh: targetDwh,
            animatedTaps: targetTaps,
            animatedDags: targetDags,
            animatedPushes: targetPushes
          });
          clearInterval(timer);
        } else {
          this.setState(prevState => ({
            animatedDwh: Math.min(Math.round(prevState.animatedDwh + dwhIncrement), targetDwh),
            animatedTaps: Math.min(Math.round(prevState.animatedTaps + tapsIncrement), targetTaps),
            animatedDags: Math.min(Math.round(prevState.animatedDags + dagsIncrement), targetDags),
            animatedPushes: Math.min(Math.round(prevState.animatedPushes + pushesIncrement), targetPushes)
          }));
        }
      }, interval);
    }
  }

  toggleDWHCreator = () =>
    this.setState({ isDWHCreatorShown: !this.state.isDWHCreatorShown });

  getMetrics = async () => {
    const response = await getMetricsService();

    if(response) {
      this.setState({ metrics: response.data });
    }
  };

  getDailyStats = async (timeframe) => {
    const response = await getDailyStatsService(timeframe);

    if(response) {
      const stats = response.data;
      const successData = stats.map((stat) => stat.success);
      const failData = stats.map((stat) => stat.failed);
      const labels = stats.map((stat) => {
        const date = new Date(stat.date);
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      });

      this.setState({
        dailyStats: {
          labels: labels,
          datasets: [
            {
              label: "DAG Success Runs",
              data: successData,
              backgroundColor: "rgba(75, 192, 192, 0.6)",
            },
            {
              label: "DAG Failed Runs",
              data: failData,
              backgroundColor: "rgba(255, 99, 132, 0.6)",
            },
          ],
        },
      });
    }
  };

  getRowJoltedData = async (timeframe) => {
    const response = await getRowJoltedDataService(timeframe);

    if(response) {
      const data = response.data;
      const labels = data.map((item) => item.date);
      const rowJoltedData = data.map((item) => item.count);

      this.setState({
        lineChartData: {
          labels: labels,
          datasets: [
            {
              label: "Row Jolted",
              data: rowJoltedData,
              borderColor: "rgba(75, 192, 192, 1)",
              backgroundColor: "rgba(75, 192, 192, 0.2)",
            },
          ],
        },
      });
    }
  };

  getRowsBySourceData = async (timeframe) => {
    try {
      const response = await axios.post(`${config.url.WEBAPP}/api/datajolt/get_rows_by_source`, { timeframe });
      
      const data = response.data;
      
      // Update available sources and tables, select all by default
      const uniqueSources = [...new Set(data.sources || [])];
      const uniqueTables = [...new Set(data.tables || [])];
      this.setState({ 
        availableSources: uniqueSources,
        selectedSources: uniqueSources,
        availableTables: uniqueTables,
        selectedTables: uniqueTables,
        rawRowsData: data // Store the raw data
      });
    } catch (error) {
      console.error("Error fetching rows by source data:", error);
    }
  };

  generateRowsChartData = () => {
    if (!this.state.rawRowsData) return { labels: [], datasets: [] };

    const data = this.state.rawRowsData;
    const isSourceView = this.state.rowsViewType === 'source';
    const currentData = isSourceView ? data.source_data : data.table_data;
    const currentOptions = isSourceView ? data.sources : data.tables;
    const selectedItems = isSourceView ? this.state.selectedSources : this.state.selectedTables;
    
    // Extract labels (dates) from the response
    const labels = currentData.map(item => {
      const date = new Date(item.date);
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    });
    
    // Create color palette for sources/tables
    const colors = [
      'rgba(85, 110, 230, 0.8)',   // Primary blue
      'rgba(46, 202, 106, 0.8)',   // Success green
      'rgba(241, 180, 76, 0.8)',   // Warning orange
      'rgba(244, 106, 106, 0.8)',  // Danger red
      'rgba(142, 213, 213, 0.8)',  // Cyan
      'rgba(156, 39, 176, 0.8)',   // Purple
      'rgba(255, 152, 0, 0.8)',    // Deep Orange
      'rgba(96, 125, 139, 0.8)',   // Blue Grey
      'rgba(139, 195, 74, 0.8)',   // Light Green
      'rgba(255, 193, 7, 0.8)',    // Amber
    ];
    
    // Create datasets for each source/table that is selected
    const datasets = currentOptions
      .filter(option => selectedItems.includes(option))
      .map((option) => {
        const data = currentData.map(item => item[option] || 0);
        const total = data.reduce((sum, value) => sum + value, 0);
        
        return {
          label: option,
          data: data,
          total: total,
          backgroundColor: '',
          borderColor: '',
          borderWidth: 1,
          stack: 'Stack 0',
        };
      })
      // Sort by total descending (biggest first, which will be at bottom of stack)
      .sort((a, b) => b.total - a.total)
      // Apply colors after sorting
      .map((dataset, index) => {
        const colorIndex = index % colors.length;
        
        return {
          ...dataset,
          backgroundColor: colors[colorIndex],
          borderColor: colors[colorIndex].replace('0.8', '1'),
        };
      });
    
    return {
      labels: labels,
      datasets: datasets
    };
  };

  getSnowflakeCosts = async (timeframe) => {
    try {
      const response = await axios.post(`${config.url.WEBAPP}/api/datajolt/get_snowflake_costs`, { timeframe: 365 });
      
      const data = response.data;
      
      // Use all of the monthly data
      let filteredData = data.daily_costs;
      
      // Extract labels (dates) directly from the response
      const labels = filteredData.map(item => item.date);
      
      // Create datasets for each warehouse
      const datasets = data.warehouses.map((warehouse, index) => {
        // Green shades based on the success green used in other charts
        const colors = [
          'rgba(142, 213, 213, 0.75)',   // mint/cyan from screenshot
          'rgba(75, 192, 192, 0.75)',   // success teal/green (same as other charts)
          'rgba(136, 132, 216, 0.75)',   // purple from user's image
        ];
        
        const colorIndex = index % colors.length;
        
        return {
          label: warehouse,
          data: filteredData.map(item => Math.round(item[warehouse] || 0)),
          backgroundColor: colors[colorIndex],
          borderColor: colors[colorIndex].replace('0.75', '1'),
          borderWidth: 1,
          stack: 'Stack 0',
        };
      });
      
      // Update state with the data
      this.setState({
        snowflakeCostsData: {
          labels: labels,
          datasets: datasets
        },
        snowflakeMtdCost: data.mtd_cost // Save MTD cost
      });
    } catch (error) {
      console.error("Error fetching Snowflake costs data:", error);
    }
  };

  getTaskRunsData = async (timeframe) => {
    try {
      const response = await axios.post(`${config.url.WEBAPP}/api/datajolt/get_task_runs`, { timeframe });
      
      const data = response.data;
      
      // Get all dates from today back to 90 days ago, as our API returns that data
      const today = new Date();
      let filteredData = data;
      
      // Filter data according to selected time range
      if (timeframe === 7 || timeframe === 30) {
        filteredData = data.slice(-timeframe);
      } else {
        // 3 months = 90 days (approximately)
        filteredData = data;
      }
      
      // Extract labels (dates)
      const labels = filteredData.map(item => {
        const date = new Date(item.date);
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      });
      
      // Prepare datasets for the chart
      const datasets = [
        // TAP TASKS
        {
          label: "Tap - Success",
          data: filteredData.map(item => item.tap.success),
          backgroundColor: "rgba(75, 192, 192, 0.6)",
          stack: "Tap",
        },
        {
          label: "Tap - Failed",
          data: filteredData.map(item => item.tap.failed),
          backgroundColor: "rgba(255, 99, 132, 0.6)",
          stack: "Tap",
        },
        {
          label: "Tap - Running",
          data: filteredData.map(item => item.tap.running),
          backgroundColor: "rgba(144, 238, 144, 0.6)",
          stack: "Tap",
        },
        // DBT MODEL TASKS
        {
          label: "DBT Model - Success",
          data: filteredData.map(item => item.dbt.success),
          backgroundColor: "rgba(75, 192, 192, 0.6)",
          stack: "DBT",
        },
        {
          label: "DBT Model - Failed",
          data: filteredData.map(item => item.dbt.failed),
          backgroundColor: "rgba(255, 99, 132, 0.6)",
          stack: "DBT",
        },
        {
          label: "DBT Model - Running",
          data: filteredData.map(item => item.dbt.running),
          backgroundColor: "rgba(144, 238, 144, 0.6)",
          stack: "DBT",
        },
        // PUSH TASKS
        {
          label: "Push - Success",
          data: filteredData.map(item => item.push.success),
          backgroundColor: "rgba(75, 192, 192, 0.6)",
          stack: "Push",
        },
        {
          label: "Push - Failed",
          data: filteredData.map(item => item.push.failed),
          backgroundColor: "rgba(255, 99, 132, 0.6)",
          stack: "Push",
        },
        {
          label: "Push - Running",
          data: filteredData.map(item => item.push.running),
          backgroundColor: "rgba(144, 238, 144, 0.6)",
          stack: "Push",
        },
      ];
      
      // Update state with the task runs data
      this.setState({
        tasksData: {
          labels: labels,
          datasets: datasets
        }
      });
    } catch (error) {
      console.error("Error fetching task runs data:", error);
    }
  };

  handleTimeRangeChange = (chartType, range) => {
    let days;
    
    switch(range) {
      case '7d':
        days = 7;
        break;
      case '30d':
        days = 30;
        break;
      case '3m':
        days = 90;
        break;
      case '6m':
        days = 180;
        break;
      case '1y':
        days = 365;
        break;
      default:
        days = 7;
    }
    
    // Update the state for the specific chart
    this.setState({ [`${chartType}TimeRange`]: range });
    
    // Fetch new data based on chart type and selected range
    switch(chartType) {
      case 'dag':
        this.getDailyStats(days);
        break;
      case 'rows':
        this.getRowJoltedData(days);
        break;
      case 'snowflake':
        this.getSnowflakeCosts(days);
        break;
      case 'tasks':
        this.getTaskRunsData(days);
        break;
      default:
        break;
    }
  };

  handleTaskTypeFilter = (type) => {
    this.setState(prevState => ({
      selectedTaskTypes: {
        ...prevState.selectedTaskTypes,
        [type]: !prevState.selectedTaskTypes[type]
      }
    }));
  }

  handleTaskStatusFilter = (event) => {
    this.setState({ taskStatusFilter: event.target.value });
  }

  handleSourceFilter = (sources) => {
    // Remove duplicates to prevent double ticks
    const uniqueSources = [...new Set(sources)];
    this.setState({ selectedSources: uniqueSources });
  }

  handleTableFilter = (tables) => {
    // Remove duplicates to prevent double ticks
    const uniqueTables = [...new Set(tables)];
    this.setState({ selectedTables: uniqueTables });
  }

  handleRowsViewToggle = (viewType) => {
    this.setState({ rowsViewType: viewType });
  }

  render() {
    const { dailyStats, emptyChartData, tasksData, taskStatusFilter } = this.state;

    // Enhanced base options for all charts
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "top",
          labels: {
            usePointStyle: true, // Uses circle instead of rectangle for legend
            padding: 15,
            font: {
              size: 12,
              family: "'Poppins', sans-serif",
            }
          }
        },
        tooltip: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          titleFont: {
            size: 14,
            weight: 'bold'
          },
          bodyFont: {
            size: 13
          },
          padding: 12,
          cornerRadius: 6,
          displayColors: true,
          usePointStyle: true,
          borderColor: 'rgba(255, 255, 255, 0.1)',
          borderWidth: 1
        }
      },
      scales: {
        x: {
          stacked: true,
          grid: {
            display: false, // Removes x-axis grid lines
            drawBorder: false,
          },
          ticks: {
            padding: 10,
            font: {
              size: 11
            }
          }
        },
        y: {
          stacked: true,
          grid: {
            color: 'rgba(200, 200, 200, 0.1)', // Lighter grid lines
            borderDash: [5, 5], // Dashed grid lines
            drawBorder: false
          },
          ticks: {
            padding: 10,
            font: {
              size: 11
            }
          }
        },
      },
      animation: {
        duration: 1500,
        easing: 'easeOutQuart'
      },
      elements: {
        bar: {
          borderRadius: 6, // Rounded bars
          borderWidth: 0
        }
      },
      layout: {
        padding: {
          top: 7,
          right: 20,
          bottom: 14,
          left: 10
        }
      }
    };

    // Enhanced DAG stats chart configuration
    const enhancedDailyStats = {
      ...dailyStats,
      datasets: [
        {
          ...dailyStats.datasets[0],
          backgroundColor: function(context) {
            const chart = context.chart;
            const {ctx, chartArea} = chart;
            if (!chartArea) {
              return 'rgba(75, 192, 192, 0.6)';
            }
            // Create gradient for success bars
            const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
            gradient.addColorStop(0, 'rgba(75, 192, 192, 0.7)');
            gradient.addColorStop(1, 'rgba(75, 192, 192, 0.9)');
            return gradient;
          },
          hoverBackgroundColor: 'rgba(75, 192, 192, 1)',
          borderRadius: 6
        },
        {
          ...dailyStats.datasets[1],
          backgroundColor: function(context) {
            const chart = context.chart;
            const {ctx, chartArea} = chart;
            if (!chartArea) {
              return 'rgba(255, 99, 132, 0.6)';
            }
            // Create gradient for failed bars
            const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
            gradient.addColorStop(0, 'rgba(255, 99, 132, 0.7)');
            gradient.addColorStop(1, 'rgba(255, 99, 132, 0.9)');
            return gradient;
          },
          hoverBackgroundColor: 'rgba(255, 99, 132, 1)',
          borderRadius: 6
        }
      ]
    };

    // Enhanced options for DAG stats chart
    const dagOptions = {
      ...options,
      plugins: {
        ...options.plugins,
        legend: {
          display: false, // Hide the legend completely
        },
        title: {
          display: true,
          text: '🚀 DAG Runs',
          font: {
            size: 16,
            weight: 'bold',
            family: "'Poppins', sans-serif",
          },
          padding: {
            top: 3,
            bottom: 14
          }
        }
      }
    };

    // Enhanced tasks chart configuration
    const enhancedTasksData = {
      ...tasksData,
      datasets: tasksData.datasets.map(dataset => {
        const isSuccess = dataset.label.includes("Success");
        const isFailed = dataset.label.includes("Failed");
        const isRunning = dataset.label.includes("Running");
        
        let baseColor, hoverColor;
        
        if (isSuccess) {
          baseColor = 'rgba(75, 192, 192, 0.85)';
          hoverColor = 'rgba(75, 192, 192, 1)';
        } else if (isFailed) {
          baseColor = 'rgba(255, 99, 132, 0.85)';
          hoverColor = 'rgba(255, 99, 132, 1)';
        } else if (isRunning) {
          baseColor = 'rgba(144, 238, 144, 0.85)';
          hoverColor = 'rgba(144, 238, 144, 1)';
        }
        
        return {
          ...dataset,
          backgroundColor: baseColor,
          hoverBackgroundColor: hoverColor,
          borderRadius: 6,
          barPercentage: 0.9, // Slightly thinner bars
          categoryPercentage: 0.8, // More spacing between categories
        };
      })
    };

    // Enhanced options for tasks chart
    const tasksOptions = {
      ...options,
      plugins: {
        ...options.plugins,
        legend: {
          display: false,
        },
        title: {
          display: true,
          text: 'Tasks Runs',
          font: {
            size: 16,
            weight: 'bold',
            family: "'Poppins', sans-serif",
          },
          padding: {
            top: 3,
            bottom: 14
          }
        },
        tooltip: {
          ...options.plugins.tooltip,
          callbacks: {
            label: function(context) {
              return '';
            },
            footer: function(tooltipItems) {
              const item = tooltipItems[0];
              const label = item.dataset.label;
              const value = item.raw;

              // Parse task type and status
              let taskType = '';
              let status = '';
              if (label.includes(' - ')) {
                [taskType, status] = label.split(' - ');
              }

              // Emoji and text for each status
              let emoji = '';
              let statusText = '';
              if (status === 'Success') {
                emoji = '✅';
                statusText = 'successful';
              } else if (status === 'Failed') {
                emoji = '❌';
                statusText = 'failed';
              } else if (status === 'Running') {
                emoji = '⏳';
                statusText = 'running...';
              }

              // Compose the new footer
              if (status) {
                if (status === 'Running' || status === 'Failed') {
                  return `${emoji} ${value} ${taskType}(s) ${statusText}`;
                } else {
                  return `${emoji} ${value} ${taskType}(s) ${statusText} runs`;
                }
              }
              return '';
            }
          }
        },
        // Add a custom plugin to draw column labels
        customCanvasBackgroundColor: {
          beforeDraw: (chart) => {
            const {ctx, chartArea, scales} = chart;
            if (!chartArea) {
              return;
            }
            
            // Draw column group labels
            ctx.save();
            ctx.font = '12px Poppins, sans-serif';
            ctx.fillStyle = '#556ee6';
            ctx.textAlign = 'center';
            
            // Calculate the x positions for each stack group
            // Each group is at position 0, 1, 2 on the x-axis scale
            const xAxis = scales.x;
            const width = chartArea.right - chartArea.left;
            const barCount = 3; // Tap, DBT Model, Exposure
            const barWidth = width / xAxis.ticks.length;
            
            // Position for each day's set of columns
            xAxis.ticks.forEach((tick, i) => {
              const x = xAxis.getPixelForTick(i);
              
              // Draw for the first day only (to avoid repeating labels)
              if (i === 0) {
                // Draw background bubbles for each label
                // Tap
                const tapX = x - (barWidth / 3);
                ctx.fillStyle = 'rgba(85, 110, 230, 0.1)';
                ctx.beginPath();
                ctx.roundRect(tapX - 24, chartArea.top - 20, 48, 16, 8);
                ctx.fill();
                
                // DBT
                const dbtX = x;
                ctx.fillStyle = 'rgba(241, 180, 76, 0.1)';
                ctx.beginPath();
                ctx.roundRect(dbtX - 24, chartArea.top - 20, 48, 16, 8);
                ctx.fill();
                
                // Exposure
                const pushX = x + (barWidth / 3);
                ctx.fillStyle = 'rgba(244, 106, 106, 0.1)';
                ctx.beginPath();
                ctx.roundRect(pushX - 24, chartArea.top - 20, 48, 16, 8);
                ctx.fill();
                
                // Draw text labels
                ctx.fillStyle = '#556ee6';
                ctx.fillText('Tap', tapX, chartArea.top - 8);
                
                ctx.fillStyle = '#f1b44c';
                ctx.fillText('DBT', dbtX, chartArea.top - 8);
                
                ctx.fillStyle = '#f46a6a';
                ctx.fillText('Push', pushX, chartArea.top - 8);
              }
            });
            
            ctx.restore();
          }
        }
      },
      // Emphasize stack grouping with stronger visual separation
      elements: {
        ...options.elements,
        bar: {
          ...options.elements.bar,
          borderWidth: 1,
          borderColor: 'rgba(255, 255, 255, 0.1)'
        }
      }
    };

    // Enhanced "Coming Soon" chart styling
    const emptyChartStyle = {
      background: 'linear-gradient(135deg, #f6f8fa 0%, #eef1f5 100%)',
      borderRadius: '12px',
      boxShadow: '0 8px 24px rgba(31, 38, 135, 0.07)',
      position: 'relative'
    };

    const comingSoonStyle = {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '2em',
      color: '#666',
      fontWeight: 'bold',
      zIndex: 10,
      backdropFilter: 'blur(3px)'
    };

    // Generate chart data dynamically based on current view type and selections
    const rowsChartData = this.generateRowsChartData();
    const enhancedRowsBySourceData = {
      ...rowsChartData,
      datasets: rowsChartData.datasets.map(dataset => ({
        ...dataset,
        backgroundColor: dataset.backgroundColor,
        hoverBackgroundColor: dataset.borderColor,
        borderRadius: 6,
        borderWidth: 1
      }))
    };

    // Enhanced options for rows by source chart
    const rowsBySourceOptions = {
      ...options,
      plugins: {
        ...options.plugins,
        legend: {
          display: false,
        },
        title: {
          display: false
        },
        tooltip: {
          ...options.plugins.tooltip,
          callbacks: {
            label: function(context) {
              return `${context.dataset.label}: ${context.raw.toLocaleString()} rows`;
            }
          }
        }
      },
      scales: {
        x: {
          stacked: true,
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            padding: 10,
            font: {
              size: 11
            }
          }
        },
        y: {
          stacked: true,
          grid: {
            color: 'rgba(200, 200, 200, 0.1)',
            borderDash: [5, 5],
            drawBorder: false
          },
          ticks: {
            padding: 10,
            font: {
              size: 11
            },
            callback: function(value) {
              return value.toLocaleString();
            }
          }
        },
      }
    };

    // Snowflake Compute Costs options
    const snowflakeCostsOptions = {
      ...options,
      plugins: {
        ...options.plugins,
        legend: {
          display: false,
          position: "top",
          align: "center",
          labels: {
            usePointStyle: true,
            padding: 10,
            boxWidth: 8,
            boxHeight: 8,
            font: {
              size: 11,
              family: "'Poppins', sans-serif",
            }
          }
        },
        title: {
          display: true,
          text: 'Snowflake Compute Costs',
          font: {
            size: 16,
            weight: 'bold',
            family: "'Poppins', sans-serif",
          },
          padding: {
            top: 3,
            bottom: 14
          }
        },
        tooltip: {
          ...options.plugins.tooltip,
          callbacks: {
            label: function(context) {
              return `${context.dataset.label}: $${context.raw.toLocaleString()}`;
            }
          }
        }
      },
      scales: {
        x: {
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            padding: 10,
            font: {
              size: 11
            }
          }
        },
        y: {
          beginAtZero: true,
          grid: {
            color: 'rgba(200, 200, 200, 0.1)',
            borderDash: [5, 5],
            drawBorder: false
          },
          ticks: {
            padding: 10,
            font: {
              size: 11
            },
            callback: function(value) {
              return '$' + value.toLocaleString();
            }
          }
        },
      }
    };

          // Add source/table filter dropdown component  
      const sourceFilterDropdown = () => {
        const isSourceView = this.state.rowsViewType === 'source';
        const currentItems = isSourceView ? this.state.availableSources : this.state.availableTables;
        const selectedItems = isSourceView ? this.state.selectedSources : this.state.selectedTables;
        const handleChange = isSourceView ? this.handleSourceFilter : this.handleTableFilter;
        const label = isSourceView ? 'Sources' : 'Tables';
        
        return (
          <div style={{
            position: 'absolute',
            right: '240px',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 5
          }}>
            <FormControl size="small" sx={{ minWidth: 140 }}>
              <InputLabel sx={{ fontSize: "10px", fontWeight: 400 }}>{label}</InputLabel>
              <Select
                multiple
                value={selectedItems}
                onChange={(e) => handleChange(e.target.value)}
                input={<OutlinedInput label={label} />}
                renderValue={() => selectedItems.length > 0 ? `${label} (${selectedItems.length})` : label}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 400,
                      marginTop: 4,
                      padding: 0,
                      overflow: 'hidden',
                    },
                    sx: {
                      '& .MuiList-root': {
                        padding: 0,
                        overflow: 'auto',
                        maxHeight: 400,
                      }
                    }
                  },
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                }}
                sx={{ 
                  maxWidth: 160,
                  fontSize: "10px",
                  fontWeight: 400,
                  "& .MuiSelect-select": {
                    fontSize: "10px",
                    fontWeight: 400
                  }
                }}
              >
                {currentItems.map(item => (
                  <MenuItem key={item} value={item} sx={{ 
                    fontSize: "10px", 
                    fontWeight: 400, 
                    wordBreak: "break-all",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 16px",
                    "&:hover": {
                      backgroundColor: "#f5f5f5"
                    }
                  }}>
                    <span style={{ flex: 1 }}>{item}</span>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>&nbsp;&nbsp;
          </div>
        );
      };

    // Add this time range selector component
    const timeRangeSelector = (chartType, activeRange = '7d') => (
      <div style={{ 
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'inline-flex',
        borderRadius: '6px',
        overflow: 'hidden',
        border: '1px solid rgba(85, 110, 230, 0.15)',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
        zIndex: 5
      }}>
        {[
          { value: '7d', label: '7d' },
          { value: '30d', label: '30d' }
        ].map(range => (
          <button
            key={range.value}
            onClick={() => this.handleTimeRangeChange(chartType, range.value)}
            style={{
              padding: '2px 5px',
              fontSize: '9px',
              fontWeight: '600',
              background: activeRange === range.value ? 'rgba(85, 110, 230, 0.12)' : 'white',
              color: activeRange === range.value ? '#556ee6' : '#666',
              border: 'none',
              borderRight: range.value !== '12m' ? '1px solid rgba(85, 110, 230, 0.15)' : 'none',
              cursor: 'pointer',
              minWidth: '28px',
              transition: 'all 0.2s ease'
            }}
          >
            {range.label}
          </button>
        ))}
      </div>
    );

    return (
      <>
        <Row sx={{ marginLeft: "5px" }}>
          <Col sx={{display: "flex"}} size={{md: 6, xl: "grow"}}>
            <Card className="flex-fill" style={{ 
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.06)', 
              borderRadius: '16px', 
              border: 'none',
              background: 'linear-gradient(145deg, #ffffff, #fcfcff)',
              overflow: 'hidden',
              transition: 'transform 0.2s, box-shadow 0.2s',
              height: '300px'
            }}>
              <Card.Body className="py-3" style={{ height: '245px' }}>
                <div style={{ textAlign: 'center', marginBottom: '16px', marginTop: '10px' }}>
                  <div className="chart-title-container" style={{ 
                    display: 'inline-block', 
                    padding: '6px 14px',
                    borderRadius: '10px',
                    background: 'rgba(85, 110, 230, 0.08)',
                    color: '#556ee6',
                    fontWeight: '600',
                    fontSize: '13px',
                    letterSpacing: '0.2px',
                    boxShadow: '0 2px 6px rgba(85, 110, 230, 0.1)',
                    border: '1px solid rgba(85, 110, 230, 0.15)'
                  }}>
                    🔌 Your Datajolt Setup
                  </div>
                </div>
                
                {/* DWH Metric Row */}
                <div className="d-flex align-items-center mb-1" style={{ padding: '2px 12px' }}>
                  <div style={{
                    width: '42px',
                    height: '42px',
                    borderRadius: '10px',
                    background: 'rgba(46, 202, 106, 0.12)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '14px',
                    boxShadow: '0 3px 8px rgba(46, 202, 106, 0.15)',
                    flexShrink: 0
                  }}>
                    <Database size={20} className="text-success" style={{ filter: 'drop-shadow(0 2px 3px rgba(46, 202, 106, 0.3))' }} />
                  </div>
                  
                  <div style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: '34px',
                    marginRight: '10px',
                    justifyContent: 'center'
                  }}>
                    <h2 style={{ 
                      fontSize: '22px', 
                      fontWeight: '700',
                      marginBottom: '0',
                      background: 'linear-gradient(45deg, #2c3e50, #4ca1af)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent'
                    }}>
                      {this.state.metrics ? (
                      this.state.animatedDwh
                      ) : (
                      <CircularProgress size={18} style={{ color: '#556ee6' }} />
                      )}
                    </h2>
                  </div>
                  
                  <p style={{ 
                    marginBottom: '0', 
                    fontSize: '12px',
                    color: '#777',
                    fontWeight: '500',
                    letterSpacing: '0.3px',
                    minWidth: '100px',
                    marginRight: '10px'
                  }}>Connected DWH(s)</p>
                  
                  <div style={{ marginLeft: 'auto', width: '140px' }}>
                <Button
                  variant="contained"
                  disabled={true}
                  onClick={this.toggleDWHCreator}
                  sx={{
                    borderRadius: '8px',
                    fontSize: '11px',
                    fontWeight: '500',
                    padding: '4px 8px',
                    boxShadow: '0 2px 6px rgba(46, 202, 106, 0.1)',
                    bgcolor: "#2eca6a",
                    color: "#fff",
                    width: "100%",
                    
                    "&:disabled": {
                      bgcolor: "#2eca6a",
                      color: "#fff"
                    }
                  }}
                  >
                  DWH connected{" "}
                  <Check size={14} style={{ marginLeft: '6px' }} />
                </Button>
                  </div>
                </div>
                
                {/* Data Taps Metric Row */}
                <div className="d-flex align-items-center mb-1" style={{ padding: '2px 12px' }}>
                  <div style={{
                    width: '42px',
                    height: '42px',
                    borderRadius: '10px',
                    background: 'rgba(85, 110, 230, 0.12)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '14px',
                    boxShadow: '0 3px 8px rgba(85, 110, 230, 0.15)',
                    flexShrink: 0
                  }}>
                    <RefreshCw size={20} className="text-primary" style={{ filter: 'drop-shadow(0 2px 3px rgba(85, 110, 230, 0.3))' }} />
                  </div>
                  
                  <div style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: '34px',
                    marginRight: '10px',
                    justifyContent: 'center'
                  }}>
                    <h2 style={{ 
                      fontSize: '22px', 
                      fontWeight: '700',
                      marginBottom: '0',
                      background: 'linear-gradient(45deg, #2c3e50, #4ca1af)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent'
                    }}>
                      {this.state.metrics ? (
                      this.state.animatedTaps
                      ) : (
                      <CircularProgress size={18} style={{ color: '#556ee6' }} />
                      )}
                    </h2>
                  </div>
                  
                  <p style={{ 
                    marginBottom: '0', 
                    fontSize: '12px',
                    color: '#777',
                    fontWeight: '500',
                    letterSpacing: '0.3px',
                    minWidth: '100px',
                    marginRight: '10px'
                  }}>Data Taps</p>
                  
                  <div style={{ marginLeft: 'auto', width: '140px' }}>
                    <Link to={"/taps/mytaps"} style={{ textDecoration: 'none', width: '100%' }}>
                    <Button
                      variant="contained"
                      sx={{
                        borderRadius: '8px',
                        fontSize: '11px',
                        fontWeight: '500',
                        padding: '4px 8px',
                        boxShadow: '0 2px 6px rgba(85, 110, 230, 0.1)',
                        bgcolor: "#3651FE",
                        color: "#fff",
                        width: "100%",
                      }}
                    >
                      Create a Data Tap
                    </Button>
                </Link>
                  </div>
                </div>
                
                {/* DAGs Scheduled Metric Row */}
                <div className="d-flex align-items-center mb-1" style={{ padding: '2px 12px' }}>
                  <div style={{
                    width: '42px',
                    height: '42px',
                    borderRadius: '10px',
                    background: 'rgba(46, 202, 106, 0.12)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '14px',
                    boxShadow: '0 3px 8px rgba(241, 180, 76, 0.15)',
                    flexShrink: 0
                  }}>
                    <Clock size={20} className="text-success" style={{ filter: 'drop-shadow(0 2px 3px rgba(241, 180, 76, 0.3))' }} />
                  </div>
                  
                  <div style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: '34px',
                    marginRight: '10px',
                    justifyContent: 'center'
                  }}>
                    <h2 style={{ 
                      fontSize: '22px', 
                      fontWeight: '700',
                      marginBottom: '0',
                      background: 'linear-gradient(45deg, #2c3e50, #4ca1af)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent'
                    }}>
                      {this.state.metrics ? (
                      this.state.animatedDags
                      ) : (
                      <CircularProgress size={18} style={{ color: '#556ee6' }} />
                      )}
                    </h2>
                  </div>
                  
                  <p style={{ 
                    marginBottom: '0', 
                    fontSize: '12px',
                    color: '#777',
                    fontWeight: '500',
                    letterSpacing: '0.3px',
                    minWidth: '100px',
                    marginRight: '10px'
                  }}>DAGs Scheduled</p>
                  
                  <div style={{ marginLeft: 'auto', width: '140px' }}>
                    <Link to={"/sql/editor"} style={{ textDecoration: 'none', width: '100%' }}>
                    <Button
                      variant="contained"
                      sx={{
                        borderRadius: '8px',
                        fontSize: '11px',
                        fontWeight: '500',
                        padding: '4px 8px',
                        boxShadow: '0 2px 6px rgba(85, 110, 230, 0.1)',
                        bgcolor: "#3651FE",
                        color: "#fff",
                        width: "100%",
                      }}
                    >
                      Create a DAG
                    </Button>
                  </Link>
                  </div>
                </div>
                
                {/* Data Pushes Metric Row */}
                <div className="d-flex align-items-center" style={{ padding: '2px 12px' }}>
                  <div style={{
                    width: '42px',
                    height: '42px',
                    borderRadius: '10px',
                    background:'rgba(52, 120, 246, 0.15)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '14px',
                    boxShadow: '0 3px 8px rgba(244, 106, 106, 0.15)',
                    flexShrink: 0
                  }}>
                    <UploadCloud
                      size={20}
                      className="text-primary"
                      style={{
                        filter: 'drop-shadow(0 2px 3px rgba(52, 120, 246, 0.3))'
                      }}
                    />
                  </div>
                  
                  <div style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: '34px',
                    marginRight: '10px',
                    justifyContent: 'center'
                  }}>
                    <h2 style={{ 
                      fontSize: '22px', 
                      fontWeight: '700',
                      marginBottom: '0',
                      background: 'linear-gradient(45deg, #2c3e50, #4ca1af)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent'
                    }}>
                      {this.state.metrics ? (
                      this.state.animatedPushes
                      ) : (
                      <CircularProgress size={18} style={{ color: '#556ee6' }} />
                      )}
                    </h2>
                  </div>
                  
                  <p style={{ 
                    marginBottom: '0', 
                    fontSize: '12px',
                    color: '#777',
                    fontWeight: '500',
                    letterSpacing: '0.3px',
                    minWidth: '100px',
                    marginRight: '10px'
                  }}>Data Pushes</p>
                  
                  <div style={{ marginLeft: 'auto', width: '140px' }}>
                    <Link to={"/jobs/push"} style={{ textDecoration: 'none', width: '100%' }}>
                      <Button
                        variant="contained"
                        sx={{
                          borderRadius: '8px',
                          fontSize: '11px',
                          fontWeight: '500',
                          padding: '4px 8px',
                          boxShadow: '0 2px 6px rgba(85, 110, 230, 0.1)',
                          bgcolor: "#3651FE",
                          color: "#fff",
                          width: "100%",
                        }}
                      >
                        Create a Push
                      </Button>
                    </Link>
                  </div>
                </div>
                
              </Card.Body>
            </Card>
          </Col>

          {/* Snowflake Compute Costs Chart */}
          <Col sx={{display: "flex"}} size={{md: 6, xl: "grow"}}>
            <Card className="flex-fill" style={{ 
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.06)', 
              borderRadius: '16px', 
              border: 'none',
              background: 'linear-gradient(to bottom, #ffffff, #fcfcfd)',
              transition: 'transform 0.2s, box-shadow 0.2s',
              overflow: 'hidden',
              height: '300px'
            }}>
              <Card.Body className="py-3" style={{ height: '245px', display: 'flex', flexDirection: 'column' }}>
                <div style={{ textAlign: 'center', marginBottom: '12px', marginTop: '10px', position: 'relative' }}>
                  <div className="chart-title-container" style={{ 
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '6px 14px',
                    borderRadius: '10px',
                    background: 'rgba(85, 110, 230, 0.08)',
                    color: '#556ee6',
                    fontWeight: '600',
                    fontSize: '13px',
                    letterSpacing: '0.2px',
                    boxShadow: '0 2px 6px rgba(85, 110, 230, 0.1)',
                    border: '1px solid rgba(85, 110, 230, 0.15)',
                    position: 'relative',
                    paddingRight: '100px' // Make room for the badge
                  }}>
                    <span>❄️ Snowflake Compute Costs</span>
                    <span style={{
                      position: 'absolute',
                      right: '10px',
                      background: 'rgba(46, 202, 106, 0.12)',
                      color: '#2eca6a',
                      padding: '2px 6px',
                      fontSize: '10px',
                      fontWeight: '600',
                      borderRadius: '6px',
                      boxShadow: '0 2px 4px rgba(46, 202, 106, 0.15)',
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                      {this.state.snowflakeMtdCost !== null ? 
                        `$${Math.ceil(this.state.snowflakeMtdCost).toLocaleString()} MTD` : 
                        <span>$ <CircularProgress size={10} style={{ color: '#2eca6a', margin: '0 2px', verticalAlign: 'middle' }} /> MTD</span>}
                    </span>
                  </div>
                </div>
                <div style={{ flex: 1, position: 'relative', padding: '0 5px' }}>
                  {this.state.snowflakeCostsData.datasets.length > 0 ? (
                    <Bar 
                      data={this.state.snowflakeCostsData} 
                      options={{
                        ...snowflakeCostsOptions,
                        plugins: {
                          ...snowflakeCostsOptions.plugins,
                          title: {
                            display: false
                          }
                        },
                        scales: {
                          ...snowflakeCostsOptions.scales,
                          x: {
                            ...snowflakeCostsOptions.scales.x,
                            ticks: {
                              ...snowflakeCostsOptions.scales.x.ticks,
                              padding: 5,
                              color: '#666'
                            }
                          },
                          y: {
                            ...snowflakeCostsOptions.scales.y,
                            ticks: {
                              ...snowflakeCostsOptions.scales.y.ticks,
                              padding: 5,
                              color: '#666',
                              callback: function(value) {
                                return '$' + value.toLocaleString();
                              }
                            },
                            grid: {
                              color: 'rgba(200, 200, 200, 0.08)', 
                              borderDash: [4, 4]
                            }
                          }
                        },
                        layout: {
                          padding: {
                            left: 10,
                            right: 10,
                            top: 0,
                            bottom: 20
                          }
                        }
                      }} 
                    />
                  ) : (
                    <div style={{ 
                      display: 'flex', 
                      flexDirection: 'column',
                      justifyContent: 'center', 
                      alignItems: 'center', 
                      height: '100%'
                    }}>
                      <DatajoltSpinner />
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Row with Daily DAG Runs and Daily Tasks Runs charts */}
        <Row sx={{ marginLeft: "5px", marginTop: "-10px" }}>
          <Col sx={{display: "flex"}} size={{md: 6, xl: "grow"}}>
            <Card className="flex-fill" style={{ 
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.06)', 
              borderRadius: '16px', 
              border: 'none',
              background: 'linear-gradient(to bottom, #ffffff, #fcfcfd)',
              transition: 'transform 0.2s, box-shadow 0.2s',
              overflow: 'hidden',
              height: '300px'
            }}>
              <Card.Body className="py-3" style={{ height: '245px', display: 'flex', flexDirection: 'column' }}>
                <div style={{ textAlign: 'center', marginBottom: '12px', marginTop: '10px', position: 'relative' }}>
                  {/* Add the failed DAGs button to the top left */}
                  <div style={{
                    position: 'absolute',
                    left: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 5
                  }}>
                    <Link to="/jobs/overview?status=failed" style={{ textDecoration: 'none' }}>
                      <button style={{
                        padding: '4px 8px',
                        borderRadius: '6px',
                        backgroundColor: 'rgba(255, 99, 132, 0.1)',
                        color: 'rgba(255, 99, 132, 1)',
                        border: '1px solid rgba(255, 99, 132, 0.3)',
                        fontSize: '10px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        boxShadow: '0 2px 4px rgba(255, 99, 132, 0.1)',
                        transition: 'all 0.2s ease'
                      }}>
                        <ExternalLink size={10} style={{ marginRight: '4px' }} />
                        Failed DAGs
                      </button>
                    </Link>
                  </div>
                  
                  <div className="chart-title-container" style={{ 
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '6px 14px',
                    borderRadius: '10px',
                    background: 'rgba(85, 110, 230, 0.08)',
                    color: '#556ee6',
                    fontWeight: '600',
                    fontSize: '13px',
                    letterSpacing: '0.2px',
                    boxShadow: '0 2px 6px rgba(85, 110, 230, 0.1)',
                    border: '1px solid rgba(85, 110, 230, 0.15)',
                    position: 'relative',
                    paddingRight: '185px' // Increased padding to make room for badge
                  }}>
                    <span>🚀 DAG Runs</span>
                    <span style={{
                      position: 'absolute',
                      right: '10px',
                      background: 'rgba(75, 192, 192, 0.12)',
                      color: '#4bc0c0',
                      padding: '2px 6px',
                      fontSize: '10px',
                      fontWeight: '600',
                      borderRadius: '6px',
                      boxShadow: '0 2px 4px rgba(75, 192, 192, 0.15)',
                      display: 'flex',
                      alignItems: 'center',
                      whiteSpace: 'nowrap'
                    }}>
                      {this.state.metrics && this.state.metrics.succesful_dag_runs ? 
                        `${this.state.metrics.succesful_dag_runs.toLocaleString()} total successful runs` : 
                        <span><CircularProgress size={10} style={{ color: '#4bc0c0', margin: '0 2px', verticalAlign: 'middle' }} /> total successful runs</span>}
                    </span>
                  </div>
                  {timeRangeSelector('dag', this.state.dagTimeRange)}
                </div>
                <div style={{ flex: 1, position: 'relative', padding: '0 5px' }}>
                  <Bar 
                    data={enhancedDailyStats} 
                    options={{
                      ...dagOptions,
                      plugins: {
                        ...dagOptions.plugins,
                        title: {
                          display: false
                        }
                      },
                      scales: {
                        ...dagOptions.scales,
                        x: {
                          ...dagOptions.scales.x,
                          ticks: {
                            ...dagOptions.scales.x.ticks,
                            padding: 5,
                            color: '#666'
                          }
                        },
                        y: {
                          ...dagOptions.scales.y,
                          ticks: {
                            ...dagOptions.scales.y.ticks,
                            padding: 5,
                            color: '#666'
                          },
                          grid: {
                            color: 'rgba(200, 200, 200, 0.08)', 
                            borderDash: [4, 4]
                          }
                        }
                      },
                      layout: {
                        padding: {
                          left: 10,
                          right: 10,
                          top: 0,
                          bottom: 20
                        }
                      }
                    }} 
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col sx={{display: "flex"}} size={{md: 6, xl: "grow"}}>
            <Card className="flex-fill" style={{ 
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.06)', 
              borderRadius: '16px', 
              border: 'none',
              background: 'linear-gradient(to bottom, #ffffff, #fcfcfd)',
              transition: 'transform 0.2s, box-shadow 0.2s',
              overflow: 'hidden',
              height: '300px'
            }}>
              <Card.Body className="py-3" style={{ height: '245px', display: 'flex', flexDirection: 'column' }}>
                <div style={{ textAlign: 'center', marginBottom: '12px', marginTop: '10px', position: 'relative' }}>
                  <div className="chart-title-container" style={{ 
                    display: 'inline-block', 
                    padding: '6px 14px',
                    borderRadius: '10px',
                    background: 'rgba(85, 110, 230, 0.08)',
                    color: '#556ee6',
                    fontWeight: '600',
                    fontSize: '13px',
                    letterSpacing: '0.2px',
                    boxShadow: '0 2px 6px rgba(85, 110, 230, 0.1)',
                    border: '1px solid rgba(85, 110, 230, 0.15)'
                  }}>
                    Tasks Runs
                  </div>
                  
                  {/* Task type filters */}
                  <div style={{ 
                    position: 'absolute',
                    left: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'inline-flex',
                    gap: '8px',
                    zIndex: 5
                  }}>
                    <button
                      onClick={() => this.handleTaskTypeFilter('tap')}
                      style={{
                        width: '28px',
                        height: '28px',
                      display: 'flex',
                        alignItems: 'center',
                      justifyContent: 'center',
                        borderRadius: '6px',
                        border: 'none',
                        background: this.state.selectedTaskTypes.tap 
                          ? 'rgba(85, 110, 230, 0.12)' 
                          : 'rgba(200, 200, 200, 0.2)',
                        cursor: 'pointer',
                        boxShadow: this.state.selectedTaskTypes.tap 
                          ? '0 2px 5px rgba(85, 110, 230, 0.15)' 
                          : 'none',
                        transition: 'all 0.2s ease'
                      }}
                      title="Filter Taps"
                    >
                      <RefreshCw 
                        size={14} 
                        className={this.state.selectedTaskTypes.tap ? "text-primary" : "text-muted"} 
                        style={this.state.selectedTaskTypes.tap ? { filter: 'drop-shadow(0 1px 2px rgba(85, 110, 230, 0.3))' } : {}} 
                      />
                    </button>
                    
                    <button
                      onClick={() => this.handleTaskTypeFilter('dbt')}
                      style={{
                        width: '28px',
                        height: '28px',
                        display: 'flex',
                      alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '6px',
                        background: 'transparent',
                        cursor: 'pointer',
                        border: this.state.selectedTaskTypes.dbt
                        ? '1.5px solid #f1b44c'
                        : '1.5px solid rgba(200, 200, 200, 0.4)',
                        boxShadow: this.state.selectedTaskTypes.dbt 
                          ? '0 2px 5px rgba(241, 180, 76, 0.15)' 
                          : 'none',
                        transition: 'all 0.2s ease'
                      }}
                      title="Filter DBT Models"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="18" width="18">
                        <desc>Dbt Icon Streamline Icon: https://streamlinehq.com</desc>
                        <path
                          fill={this.state.selectedTaskTypes.dbt ? "#ff694a" : "#bbb"}
                          d="M22.75135 1.2273975C23.303775 1.75859 23.665 2.459765 23.75 3.224675c0 0.318725 -0.085 0.5312 -0.276225 0.934925 -0.191225 0.4037 -2.549725 4.483275 -3.2509 5.6094 -0.4037 0.658675 -0.616175 1.44485 -0.616175 2.20975 0 0.786175 0.212475 1.5511 0.616175 2.209775 0.701175 1.126125 3.059675 5.226925 3.2509 5.63065C23.665 20.222875 23.75 20.4141 23.75 20.7328c-0.085 0.764925 -0.42495 1.466125 -0.9774 1.976075 -0.5312 0.552425 -1.23235 0.91365 -1.976025 0.977375 -0.318725 0 -0.5312 -0.084975 -0.91365 -0.276225 -0.382475 -0.191225 -4.547025 -2.485975 -5.673175 -3.18715 -0.084975 -0.0425 -0.169975 -0.106225 -0.2762 -0.14875L8.36665 16.780725c0.127475 1.0624 0.594925 2.0823 1.359825 2.825975 0.14875 0.148725 0.2975 0.276225 0.467475 0.4037 -0.1275 0.063725 -0.276225 0.1275 -0.4037 0.212475 -1.12615 0.701175 -5.22695 3.059675 -5.63065 3.2509C3.755875 23.665 3.56465 23.75 3.224675 23.75c-0.76491 -0.085 -1.466085 -0.42495 -1.9760325 -0.9774C0.6962025 22.2414 0.33499 21.54025 0.25 20.775325c0.0212475 -0.318725 0.10624 -0.637425 0.2762225 -0.91365 0.19123 -0.403725 2.5497275 -4.50455 3.2509025 -5.630675 0.403725 -0.658675 0.616175 -1.4236 0.616175 -2.20975 0 -0.786175 -0.21245 -1.5511 -0.616175 -2.209775 -0.701175 -1.1686 -3.0809225 -5.269425 -3.2509025 -5.67315C0.35624 3.8621 0.2712475 3.5434 0.25 3.224675c0.08499 -0.76491 0.424955 -1.466085 0.9773975 -1.9972775C1.75859 0.674955 2.459765 0.33499 3.224675 0.25c0.318725 0.0212475 0.637425 0.10624 0.934925 0.2762225 0.33995 0.1487325 3.335875 1.8910475 4.92945 2.8259525l0.361225 0.212475c0.127475 0.085 0.233725 0.148725 0.318725 0.191225l0.169975 0.106225 5.673125 3.357175c-0.127475 -1.274875 -0.78615 -2.443525 -1.80605 -3.229675 0.1275 -0.063725 0.276225 -0.1275 0.4037 -0.212475 1.12615 -0.701175 5.22695 -3.0809225 5.63065 -3.2509025 0.27625 -0.1699825 0.59495 -0.254975 0.934925 -0.2762225 0.743675 0.08499 1.44485 0.424955 1.976025 0.9773975ZM12.29745 13.5086l1.21115 -1.21115c0.169975 -0.169975 0.169975 -0.424925 0 -0.5949l-1.21115 -1.21115c-0.169975 -0.169975 -0.424925 -0.169975 -0.5949 0l-1.21115 1.21115c-0.169975 0.169975 -0.169975 0.424925 0 0.5949l1.21115 1.21115c0.148725 0.148725 0.424925 0.148725 0.5949 0Z"
                          strokeWidth="0.25"
                        />
                      </svg>
                    </button>
                    
                    <button
                      onClick={() => this.handleTaskTypeFilter('push')}
                      style={{
                        width: '28px',
                        height: '28px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '6px',
                        border: 'none',
                        background: this.state.selectedTaskTypes.push 
                          ? 'rgba(52, 120, 246, 0.15)'
                          : 'rgba(200, 200, 200, 0.2)',
                        cursor: 'pointer',
                        boxShadow: this.state.selectedTaskTypes.push 
                          ? '0 2px 5px rgba(52, 120, 246, 0.15)'
                          : 'none',
                        transition: 'all 0.2s ease'
                      }}
                      title="Filter Push"
                    >
                      <UploadCloud 
                        size={14} 
                        className={this.state.selectedTaskTypes.push ? "text-primary" : "text-muted"} 
                        style={this.state.selectedTaskTypes.push 
                          ? { filter: 'drop-shadow(0 1px 2px rgba(52, 120, 246, 0.3))' } 
                          : {}} 
                      />
                    </button>
                  </div>
                  {/* Status filter dropdown */}
                  <div style={{
                    position: 'absolute',
                    right: '100px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 5
                  }}>
                    <FormControl size="small" sx={{ minWidth: 120 }}>
                      <InputLabel sx={{ fontSize: "10px", fontWeight: 400 }}>Status</InputLabel>
                      <Select
                        value={this.state.taskStatusFilter}
                        onChange={this.handleTaskStatusFilter}
                        input={<OutlinedInput label="Status" />}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 400,
                              marginTop: 4,
                              padding: 0,
                              overflow: 'hidden',
                            },
                            sx: {
                              '& .MuiList-root': {
                                padding: 0,
                                overflow: 'auto',
                                maxHeight: 400,
                              }
                            }
                          },
                          anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                          },
                          transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                          },
                        }}
                        sx={{ 
                          maxWidth: 140,
                          fontSize: "10px",
                          fontWeight: 400,
                          "& .MuiSelect-select": {
                            fontSize: "10px",
                            fontWeight: 400
                          }
                        }}
                      >
                        <MenuItem value="all" sx={{ fontSize: "10px", fontWeight: 400 }}>All Statuses</MenuItem>
                        <MenuItem value="success" sx={{ fontSize: "10px", fontWeight: 400 }}>Success</MenuItem>
                        <MenuItem value="failed" sx={{ fontSize: "10px", fontWeight: 400 }}>Failed</MenuItem>
                      </Select>
                    </FormControl>&nbsp;&nbsp;
                  </div>
                  {timeRangeSelector('tasks', this.state.tasksTimeRange)}
                </div>
                
                <div style={{ flex: 1, position: 'relative', padding: '0 5px' }}>
                  <Bar 
                    data={{
                      ...enhancedTasksData,
                      datasets: enhancedTasksData.datasets.filter(dataset => {
                        // Filter by task type
                        if (!this.state.selectedTaskTypes.tap && dataset.stack === "Tap") return false;
                        if (!this.state.selectedTaskTypes.dbt && dataset.stack === "DBT") return false;
                        if (!this.state.selectedTaskTypes.push && dataset.stack === "Push") return false;
                        // Filter by status
                        if (this.state.taskStatusFilter === "success" && !dataset.label.toLowerCase().includes("success")) return false;
                        if (this.state.taskStatusFilter === "failed" && !dataset.label.toLowerCase().includes("failed")) return false;
                        return true;
                      })
                    }} 
                    options={{
                      ...tasksOptions,
                      plugins: {
                        ...tasksOptions.plugins,
                        title: {
                          display: false
                        },
                        tooltip: {
                          ...tasksOptions.plugins.tooltip,
                          callbacks: {
                            ...tasksOptions.plugins.tooltip.callbacks,
                          }
                        },
                        customCanvasBackgroundColor: undefined
                      },
                      scales: {
                        ...tasksOptions.scales,
                        x: {
                          ...tasksOptions.scales.x,
                          ticks: {
                            ...tasksOptions.scales.x.ticks,
                            padding: 5,
                            color: '#666'
                          }
                        },
                        y: {
                          ...tasksOptions.scales.y,
                          ticks: {
                            ...tasksOptions.scales.y.ticks,
                            padding: 5,
                            color: '#666'
                          },
                          grid: {
                            color: 'rgba(200, 200, 200, 0.08)', 
                            borderDash: [4, 4]
                          }
                        }
                      },
                      layout: {
                        padding: {
                          left: 10,
                          right: 10,
                          top: 0,
                          bottom: 20
                        }
                      }
                    }} 
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row style={{ marginLeft: "5px", marginTop: "-10px" }}>
          <Col sx={{display: "flex"}} size={{md: 12, xl: "grow"}}>
            <Card className="flex-fill" style={{ 
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.06)', 
              borderRadius: '16px', 
              border: 'none',
              background: 'linear-gradient(to bottom, #ffffff, #fcfcfd)',
              transition: 'transform 0.2s, box-shadow 0.2s',
              overflow: 'hidden'
            }}>
              <Card.Body className="py-3" style={{ height: '400px', display: 'flex', flexDirection: 'column' }}>
                <div style={{ textAlign: 'center', marginBottom: '12px', marginTop: '10px', position: 'relative' }}>
                  <div className="chart-title-container" style={{ 
                    display: 'inline-block', 
                    padding: '6px 14px',
                    borderRadius: '10px',
                    background: 'rgba(85, 110, 230, 0.08)',
                    color: '#556ee6',
                    fontWeight: '600',
                    fontSize: '13px',
                    letterSpacing: '0.2px',
                    boxShadow: '0 2px 6px rgba(85, 110, 230, 0.1)',
                    border: '1px solid rgba(85, 110, 230, 0.15)'
                  }}>
                    📊 Rows Replicated
                  </div>
                  {timeRangeSelector('rows', this.state.rowsTimeRange)}
                </div>
                <div style={{ flex: 1, position: 'relative', padding: '0 5px' }}>
                  <div style={{
                    ...emptyChartStyle,
                    background: 'linear-gradient(135deg, #f8fafc 0%, #eef2f7 100%)',
                    borderRadius: '12px',
                    boxShadow: 'none',
                    border: '1px dashed rgba(200, 200, 200, 0.5)',
                    height: '100%'
                  }}>
                    <Bar 
                      data={emptyChartData} 
                      options={{
                        ...options,
                        plugins: {
                          ...options.plugins,
                          title: {
                            display: false
                          }
                        },
                        scales: {
                          ...options.scales,
                          x: {
                            ...options.scales.x,
                            ticks: {
                              ...options.scales.x.ticks,
                              padding: 5,
                              color: '#888'
                            }
                          },
                          y: {
                            ...options.scales.y,
                            ticks: {
                              ...options.scales.y.ticks,
                              padding: 5,
                              color: '#888'
                            },
                            grid: {
                              color: 'rgba(200, 200, 200, 0.08)', 
                              borderDash: [4, 4]
                            }
                          }
                        },
                        layout: {
                          padding: {
                            left: 10,
                            right: 10,
                            top: 0,
                            bottom: 20
                          }
                        }
                      }} 
                    />
                    <div style={{
                      ...comingSoonStyle,
                      backgroundColor: 'rgba(255, 255, 255, 0.7)',
                      backdropFilter: 'blur(5px)',
                      color: '#555',
                      fontWeight: '600',
                      letterSpacing: '0.5px'
                    }}>
                      <div style={{ 
                        fontSize: '0.45em', 
                        marginTop: '12px', 
                        fontWeight: 'normal', 
                        color: '#777',
                        padding: '8px 16px',
                        background: 'rgba(255, 255, 255, 0.7)',
                        borderRadius: '20px',
                        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.04)'
                      }}>
                        Coming soon...
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}
